import styled from 'styled-components';

const Form = styled.div`
  background-color: #f0f0f0;
  padding: 10px;
  width: 20vw;
`;

export default Form;
